export interface Vec3 {
  x: number;
  y: number;
  z: number;
}

export interface Edge {
  id: number;
  from: number;
  to: number;
  length: number;
  width: number;
  /** Flat x,y,z triples sampled along the edge. */
  points: Float32Array;
}

export interface Route {
  id: number;
  name: string;
  edgeIds: number[];
  distanceM: number;
  climbM: number;
}

export type SegmentType = "sprint" | "kom" | "cobble";

export interface Segment {
  id: number;
  name: string;
  edgeStart: number;
  edgeEnd: number;
  sStart: number;
  sEnd: number;
  type: SegmentType;
}

export interface WorldRef {
  getEdge(id: number): Edge | undefined;
  edgeLength(id: number): number;
  sampleGrade(edgeId: number, s: number): number;
  nextEdge(edgeId: number, s: number): number | null;
  samplePosition(edgeId: number, s: number): Vec3;
}

export interface RiderConfig {
  /** Total moving mass: rider + bike + kit, kilograms. */
  massKg: number;
  cda: number;
  crr: number;
  drivetrainEff: number;
}

export interface RiderState {
  riderId: number;
  edgeId: number;
  s: number;
  lane: number;
  speed: number;
  power: number;
  distance: number;
}

export interface RiderInput {
  watts: number;
  cadence: number;
  hr?: number;
}

export const DEFAULT_RIDER_CONFIG: RiderConfig = {
  massKg: 75,
  cda: 0.36,
  crr: 0.004,
  drivetrainEff: 0.97,
};

export const MAX_GRADE = 0.22;
export const CODE_GRADE_CLAMP = 0.25;
export const MAX_SPEED_MPS = 25;
export const MAX_ACCEL_MPS2 = 3;
